module.exports = __webpack_public_path__ + "static/img/p05.4aa7e63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comic/001/p05.jpg
// module id = 118
// module chunks = 0